import * as yup from 'yup';

import {
  LC_PAGE_COMPETENCY_CHAR_LIMIT,
  LC_PAGE_SUBJECT_CHAR_LIMIT,
} from '@lessonPlanner/constants';

// Individual schema fields
export const subjectSchema = yup
  .string()
  .required('Please enter a subject')
  .test(
    'len',
    'You have reached the character limit',
    (val: any) => val.length <= LC_PAGE_SUBJECT_CHAR_LIMIT,
  );

export const gradeLevelSchema = yup
  .string()
  .required('Please select a grade level');

export const objectiveSchema = yup
  .string()
  .required('Please enter objective')
  .test(
    'len',
    'You have reached the character limit',
    (val: any) => val.length <= LC_PAGE_COMPETENCY_CHAR_LIMIT,
  );

export const languageSchema = yup
  .string()
  .required('Please select a translation');

export const difficultySchema = yup
  .string()
  .required('Please select a difficulty');

export const materialsSchema = yup.string().required('Please enter materials');

export const timeSchema = yup.string().required('Please select a time');

export const curriculumFrameworkSchema = yup
  .string()
  .required('Please select a curriculum framework');

export const specificStandardsSchema = yup
  .string()
  .required('Please enter specific standards')
  .test(
    'len',
    'You have reached the character limit',
    (val: any) => val.length <= LC_PAGE_COMPETENCY_CHAR_LIMIT,
  );

export const strategiesSchema = yup
  .string()
  .required('Please enter teaching strategies')
  .test(
    'len',
    'You have reached the character limit',
    (val: any) => val.length <= LC_PAGE_COMPETENCY_CHAR_LIMIT,
  );
